export default {
  activity_tutorial_01: {
    title: 'I did a climate friendly activity today',
    description: 'Registered every time you do something great for the planet!',
  },
};
